<template>
    <div>
      <div class>
        <div class="five">
          <div class="row d-flex flex-wrap align-items-stretch">
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Nom :</p>
                    <d-input v-if="edit" type="text" v-model="request.lastName" />
                    <span v-else>{{
                      request.lastName ? request.lastName : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Prénom :</p>
                    <d-input v-if="edit" type="text" v-model="request.firstName" />
                    <span v-else>{{
                      request.firstName ? request.firstName : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Titre  :</p>
                    <select v-if="edit" class="form-control" v-model="request.isMale" name="updated">
                      <option value="false">Madame</option>
                      <option value="true">Monsieur</option>
                    </select>
                    <span v-else>{{
                      request.isMale ? "Monsieur" : "Madame"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <div class="col-2 svg-wrapper">
                    <svg
                    width="44px"
                    height="44px"
                    viewBox="0 0 44 44"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                    <title>Iconspace_Calendar</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Antarmuka_One-Color-UI-element-1"
                        transform="translate(-338.000000, -242.000000)"
                      >
                        <g
                          id="Iconspace_Calendar"
                          transform="translate(336.000000, 240.000000)"
                        >
                          <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                          <path
                            d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                            id="Shape"
                            fill="#303778"
                            fill-rule="nonzero"
                          />
                          <polygon
                            id="Shape"
                            fill="#303778"
                            points="10 18 18 18 18 26 10 26"
                          />
                        </g>
                      </g>
                    </g>
                    </svg>
                  </div>
                  <div class="col-10">
                    <p>Date de naissance :</p>
                    <d-datepicker
                      v-if="edit"
                      id="datepicker"
                      class="pr-1"
                      v-model="request.dateOfBirth"
                      placeholder="Date de naissance"
                      :input-class="['form-control', 'datepicker', 'py-3']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <span v-else>{{
                       new Date(request.dateOfBirth).toLocaleDateString("fr-FR")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Lieu de naissance :</p>
                    <d-input v-if="edit" type="text" v-model="request.birthPlace" />
                    <span v-else>{{
                      request.birthPlace ? request.birthPlace : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Nationalité :</p>
                    <d-input v-if="edit" type="text" v-model="request.nationality" />
                    <span v-else>{{
                      request.nationality ? request.nationality : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Tél. :</p>
                    <d-input v-if="edit" type="text" v-model="request.phoneNumber" />
                    <span v-else>{{
                      request.phoneNumber ? request.phoneNumber : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Adresse :</p>
                    <d-input v-if="edit" type="text" v-model="request.address" />
                    <span v-else>{{
                      request.adresse ? request.adresse : request.address
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Adresse mail :</p>
                    <d-input v-if="edit" type="text" v-model="request.email" />
                    <span v-else>{{
                      request.email ? request.email : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Code postal :</p>
                    <d-input v-if="edit" type="text" v-model="request.postalCode" />
                    <span v-else>{{
                      request.postalCode ? request.postalCode : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Ville :</p>
                    <d-input v-if="edit" type="text" v-model="request.city" />
                    <span v-else>{{
                      request.city ? request.city : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Numéro de sécurité sociale :</p>
                    <d-input v-if="edit" type="text" v-model="request.socialSecurityNumber" />
                    <span v-else>{{
                      request.socialSecurityNumber ? request.socialSecurityNumber : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Numéro Pôle Emploi :</p>
                    <d-input v-if="edit" type="text" v-model="request.poleEmploiInscriptionNumber" />
                    <span v-else>{{
                      request.poleEmploiInscriptionNumber ? request.poleEmploiInscriptionNumber : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Date de début :</p>
                    <d-datepicker
                      v-if="edit"
                      id="datepicker"
                      class="pr-1"
                      v-model="request.dateFrom"
                      placeholder="Date de début"
                      @input="checkDates"
                      :input-class="['form-control', 'datepicker', 'py-3']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <span v-else>{{
                      new Date(request.dateFrom).toLocaleDateString("fr-FR")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Date de fin :</p>
                    <d-datepicker
                      v-if="edit"
                      id="datepicker"
                      class="pr-1"
                      v-model="request.dateTo"
                      placeholder="Date de fin"
                      @input="checkDates"
                      :input-class="['form-control', 'datepicker', 'py-3']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <span v-else>{{
                      request.dateTo ? new Date(request.dateTo).toLocaleDateString("fr-FR") : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Type de contrat :</p>
                    <select v-if="edit" class="form-control" v-model="request.typeOfContract" name="contractTypes" id="contractTypes">
                      <option v-for="typeC in contractType" :value="typeC.value"> {{ typeC.name }}</option>
                    </select>
                    <span v-else><span>{{
                      request.typeOfContract ? request.typeOfContract : type  
                    }}</span>
                    <div>{{ request.typeOfContract == 'OTHER' ?  request.otherContract : ""}}</div>
                  </span>
                    <span v-if="edit && request.typeOfContract == 'OTHER'" >Expliquez ici :</span>
                    <d-input v-if="edit && request.typeOfContract == 'OTHER'" type="text" v-model="request.otherContract" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Dossier à jour :</p>
                    <select v-if="edit" class="form-control" v-model="request.upToDate" name="updated">
                      <option value="false">Non</option>
                      <option value="true">Oui</option>
                    </select>
                    <span v-else>{{
                      request.upToDate ? "Oui" : "Non"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Structure :</p>
                    <select v-if="edit" class="form-control" v-model="selStr" @change="handleSelectStructure" name="structure">
                      <option v-for="str in allStructures" :value="str">{{ str.name }}</option>
                    </select>
                    <span v-else>{{
                      // request.selectedStructure.name ? request.selectedStructure.name: request.structureID
                      request.structureName ? request.structureName : request.selectedStructure.name
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="request.type != 'CEE'" class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Fonction :</p>
                    <d-input v-if="edit" type="text" v-model="request.fonction" />
                    <span v-else>{{
                      request.fonction ? request.fonction : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="request.CEEType" class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Type de CEE :</p>
                    <select v-if="edit" class="form-control" v-model="request.CEEType" name="CEEType">
                      <option v-for="str in typesCEE" :value="str">{{ str }}</option>
                    </select>
                    <span v-else>{{
                      request.CEEType ? request.CEEType : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Nombre de jours du contrat :</p>
                    <d-input v-if="edit" type="text" v-model="request.daysOfContract" />
                    <span v-else>{{
                      request.daysOfContract ? request.daysOfContract : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="request.type == 'CEE'" class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Nombre de jour(s) travaillé(s) en qualité d'engagé éducatif sur les 11 derniers mois :</p>
                    <d-input v-if="edit" type="text" v-model="request.daysOfContractPast11Months" />
                    <span v-else>{{
                      request.daysOfContractPast11Months ? request.daysOfContractPast11Months : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </template>
  
  <script>
  import contractType from '../../data/contract/contractType';
  import SvgIcon from '../shared/SvgIcon.vue';
  
  export default {
    name: 'RecapitulatifContractRequest',
    components: {
      SvgIcon,
    },
    props: {
      request: Object,
      edit: Boolean,
      all: Boolean,
      showLastTwo: Boolean,
      allStructures: Array,
    },
    data() {
      return {
        contractType,
        selStr: null,
        typesCEE: ['Séjour de vacances', 'ACM'],
      };
    },
    computed: {
      type() {
        return this.contractType[this.request.type].name;
      },
    },
    methods: {
      handleSelectStructure() {
        this.request.structureID = this.selStr.reference;
        this.request.structureName = this.selStr.name;
      }
    },
  };
  </script>
  
  <style scoped>
  .step4-card {
    padding: 15px;
    min-height: 70px;
    border-radius: 0;
    border-left: 5px solid #303778;
    margin-bottom: 5px;
    background-color: #f6f8ff;
    height: 100%;
  }
  .svg-wrapper svg {
    height: 20px;
  }
  
  .step4-card p {
    color: #32356b;
  }
  .step4-card span {
    color: #6c7899;
  }
  </style>
  